// Feature flags for gating in-progress work.
//
// PARTNERS_ENABLED — controls the "Our Partners" page (/partners route) and its
// link in the About Us nav dropdown. It's tied to `import.meta.env.DEV`, so:
//   • `npm run dev` (local)      → DEV is true  → page + nav link visible
//   • production build (Vercel)  → DEV is false → route 404s, nav link hidden
//
// The page still ships in the bundle; it's just not reachable or linked on the
// live site while it's being finalized.
//
// To launch it publicly: change this to `export const PARTNERS_ENABLED = true;`
// (or wire it to an env var like `import.meta.env.VITE_SHOW_PARTNERS === "true"`).
export const PARTNERS_ENABLED = import.meta.env.DEV;
